"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.status.pending': '待处理',
    'onboarding.status.in_progress': '进行中',
    'onboarding.status.completed': '已完成',
    'onboarding.status.all': '所有状态',
    'onboarding.status.abandoned': '已放弃',
    'onboarding.status.unknown': '未知',
};
